import { render, staticRenderFns } from "./_scrim.vue?vue&type=template&id=0b013c4e&"
import script from "./_scrim.vue?vue&type=script&lang=ts&"
export * from "./_scrim.vue?vue&type=script&lang=ts&"
import style0 from "./_scrim.vue?vue&type=style&index=0&id=0b013c4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports